import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {del, get, post, put} from "../../common/network";
import useSweetAlert from "../../components/common/alert/useSweetAlert";
import FallbackGeneratedFormMessage from "../../components/common/fallback-form-message/FallbackGeneratedFormMessage";
import FormSearchFilter from "../../components/common/form-search-filter/FormSearchFilter";
import DownloadTypeModal from "../../components/common/modal-preview/DownloadTypeModal";
import MuiTableWrapper from "../../components/common/mui-table-wrapper/MuiTableWrapper";
import SendForSignature from "../../components/common/send-for-signature/SendForSignature";
import UpdateFileStatus from "../../components/common/update-file-status/updateFileStatus";
import UpdateStatus from "../../components/common/update-status/UpdateStatus";
import NotificationContainer from "../../components/filing/NotificationContainer";
import {applicantFormCodes, assigneeTenants, inventorFormCodes, tenant} from "../../constants";
import {DateFormatter} from "../../constants/date_format";
import MatterDetailsModal from "../matters/matter-details/MatterDetailsModal";


const AllFormsListing = (props) => {
  //#region for states
  const [isMatterDetailsOpen, setIsMatterDetailsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [updateStatusModalOpen, setUpdateStatusModalOpen] = useState(false);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [isSignModalOpen, setIsSignModalOpen] = useState(false); // preview form modal popup
  const [items, setItems] = useState([]);
  const [isRowId, setIsRowId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState([]);
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [formTypeValue, setFormTypeValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [selectType, setSelectType] = useState(null);
  const [downloadTypeModal,setDownloadTypeModal] = useState(false);
  const [isXfa, setIsXfa] = useState(false);
  const [readyToFile, setReadyToFile] = useState(false);
  const [rowsSelection,setRowsSelection] = useState([]);
  const [generatedFormData,setGeneratedFormData] = useState([]);
  const [notification,setNotification] = useState({type:"",message:""});

  useEffect(() => {
    let docketId;

    if (selectedRows.length) {
      let readyToFile = true;
      for (let i = 0; i < selectedRows.length; i++) {
        const {status, matter_id: matterId} = selectedRows[i];

        if (i === 0) {
          docketId = matterId;
        }

        const filteredData = data?.filter((item) => item.matter_id === docketId &&
        (item.status === "Completed" || item.status === "Pending for sign") &&
        item.generated_form.filingName?.trim()
        );

        if (filteredData?.length > 0) {
          readyToFile = true;
          setGeneratedFormData(filteredData);
        }

        if (!(docketId === matterId && (status === "Completed" || status === "Pending for sign"))) {
          readyToFile = false;
          break;
        }
      }
      setReadyToFile(readyToFile);
    } else {
      setReadyToFile(false);
    }
  }, [selectedRows]);

  //#endregion

  //#region for hooks
  const sweetAlert = useSweetAlert();
  //#endregion

  //#region for functions
  const allItemsHaveDesiredStatus = selectedRows.every(
    (item) => item.status === "Draft"
  );

  //#region for functions
  const allItemsHaveDesiredStatusForSign = selectedRows.every(
    (item) => item.status === "Pending for sign"
  );

  //#region for functions
  const allItemsHaveDesiredStatusForUpdateStatus = selectedRows.every(
    (item) => item.status === "Ack. Awaited" || item.status === "Saved in Workbench"
  );

  // UPDATE STATUS MODAL FUNCTIONS
  const handleUpdateStatusModalClose = () => {
    setUpdateStatusModalOpen(false);
  };
  const handleUpdateStatusModalSubmit = async (values) => {
    try {
      const response = await put(`docgen/all-generated-forms-status`, {
        data: [values],
      });
      if (response?.success === true) {
        toast.success(response.message);
        fetchData();
      }
    } catch (error) {
    } finally{
      setSelectedRows([]);
    }

  };
  // UPDATE STATUS MODAL FUNCTIONS

  // HANDLE DELETE FUNCTION
  const handleDelete = () => {
    sweetAlert({
      text: "Are you sure you want to delete the selected form(s)?",
      icon: "warning",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed == true) {
        deleteMatter(result);
      }
    });
  };
  // HANDLE DELETE FUNCTION

  // FILE BUTTON FUNCTIONS
  const handleFileModalClose = () => {
    setFileModalOpen(false);
  };

  const handleFileModalSubmit = async (values) => {
    try {
      const response = await put(`docgen/all-generated-forms-status`, {
        data: [values],
      });
      if (response?.success === true) {
        toast.success(response.message);
        fetchData();
      }
    } catch (error) {
    } finally {
      setSelectedRows([]);
    }
  };

  // FILE BUTTON FUNCTIONS

  // SIGNING MODAL FUNCTIONS
  const handleSignModalClose = () => {
    setIsSignModalOpen(false);
  };

  const handleSendForSign = async (value) => {
    try {
         // toaster("info", "Sending Document for E-signing");
      toast.info("Sending Document for E-signing");
      // Convert the data to the desired format
      const emails = value.map((email) => email.value).join(",");
      const names = value.map((name) => name.label).join(",");

      // Create the formatted object
      const formattedData = {
        emails,
        names,
        form_id: value[0]?.form_id || "", // Modify this based on your actual data
      };
      const response = await post(`docgen/docusign`, formattedData);
      if (response?.success === true) {
        toast.success(response.message);
      }
    } catch (error) {
    } finally {
      setSelectedRows([]);
    }

  };
  // SIGNING MODAL FUNCTIONS

  //#endregion

  //#region of API callings
  //call delete api
  const deleteMatter = async (result) => {
    try{
      const selectedIds = [];
      for (const row of selectedRows) {
        selectedIds.push(row.id);
      }
      const response = await del(`docgen/generate-forms`, {
        formIds: selectedIds,
      });
      if (response?.success === true) {
        toast.success(response.message);
        fetchData();
      }
    } catch (error) {
    } finally {
      setSelectedRows([]);
      setRowsSelection([])
    }

  };

  const handleRedirect = () => {
    const queryParams = new URLSearchParams();
    const selectedIds = [];
    for (const row of selectedRows) {
      selectedIds.push(row.id);
    }
    selectedIds.forEach((id) => queryParams.append("id", id));
    window.open(`/docgen/drafts/modify?` + queryParams);
  };

  const handlePreviewRedirect = () => {
    const queryParams = new URLSearchParams();
    const selectedIds = [];
    for (const row of selectedRows) {
      selectedIds.push(row.id);
    }
    selectedIds.forEach((id) => queryParams.append("id", id));
    window.open(`/docgen/drafts/preview?` + queryParams);
  };

  // HANDLE DOWNLOAD FUNCTION
  const handleDownload = () => {
    const isCustomForm = selectedRows?.some((form)=> form?.generated_form?.form_type === "custom");
    if (isCustomForm) {
        setDownloadTypeModal(true);
    } else {
        downloadForms();
    }
  };
  // HANDLE DOWNLOAD FUNCTION

  //call download api
  const downloadForms = async () => {
    try {
      setIsLoading(true);
      const selectedIds = [];
      for (const row of selectedRows) {
        selectedIds.push(row.id);
      }
      const response = await post(
        `docgen/generated-forms/download`,
        {
          form_id: selectedIds,
          downloadType:selectType
        },
        {
          responseType: "blob", // Specify that you expect a Blob response
        },
        false
      );
      // Get the current timestamp
      const timestamp = new Date().getTime();


      const contentDispositionHeader =
          response?.headers["content-disposition"];
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDispositionHeader);
        let suggestedFilename;
        if (selectedIds.length!==1) {
            suggestedFilename = `forms-${timestamp}.zip`;
        } else {
            suggestedFilename = matches && matches[1] ? matches[1].replace(/['"]/g, "") : `Custom Form.${selectType || "pdf"}`
        }

      // Create a Blob from the response content
        const mimeType = response?.headers["content-type"];
        const blob = new Blob([response.data], {type: mimeType});

        // Create a URL for the blob response
        const url = URL.createObjectURL(blob);

        // Create a hidden anchor element
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = url;
        anchor.download = suggestedFilename; // Set the desired file name

        // Append the anchor to the document body
        document.body.appendChild(anchor);

        // Simulate a click on the anchor to trigger the download
        anchor.click();

        // Remove the anchor from the document body
        document.body.removeChild(anchor);
        toast.success("Form downloaded successfully");

    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  //#region for column declaration
  const columns = [
    {
      field: "host_file_number",
      header: "Docket No.",
      render: (value, row) => {
        return (
            <div
            style={{textDecoration:"underline", cursor:"pointer", paddingTop:"1%", paddingBottom:"1%"}}
            onClick={() => {
                setIsMatterDetailsOpen(true);
                setIsRowId(row?.generated_form_matter?.id);
                setIsXfa(row?.generated_form?.isXfa);
              }}
          >
            {row?.generated_form_matter?.host_file_number}
          </div>
        );
      },
    },
    {
      field: "form_code",
      header: "Form Code",
      render: (value, row) => {
        if (inventorFormCodes.includes(row?.generated_form?.form_code)) {
          const inventorList = row?.generated_form_matter?.matter_parties?.filter(matter => matter?.party_type === "Inventor")?.map(contact => contact?.party?.name);
          const selectedInventor = inventorList?.find(inventor => row.contactName === inventor);
          if (selectedInventor) {
            return `${row?.generated_form?.form_code}_${selectedInventor}`;
          }
        } else if (applicantFormCodes.includes(row?.generated_form?.form_code)) {
          const applicantList = row?.generated_form_matter?.matter_parties?.filter(matter => matter?.party_type === (assigneeTenants.has(tenant) ? "Assignee" : "Applicant"))?.map(contact => contact?.party?.name);
          const selectedApplicant = applicantList?.find(applicant => row.contactName === applicant);
          if (selectedApplicant) {
            return `${row?.generated_form?.form_code}_${selectedApplicant}`;
          }
        }
        return row?.generated_form?.form_code;
      },
    },
    {
      field: "application_number",
      header: "Application No.",
      render: (value, row) => {
        return row?.generated_form_matter?.application_number;
      },
    },
    {
      field: "status",
      header: "Status",
    },
    {
      field: "updated_at",
      header: "Updated On",
      render: (value) => {
        const date = new Date(value); // Convert the ISO date string to a Date object
        return DateFormatter(date);
      },
    },
  ];

  const handleSearch = (value) => {
    const columnName = value?.value || ""; // Name of the column
    const searchValue = value?.searchedText || ""; // Value entered in the input field
    const dropdownValue = value?.dropdownValue || ""; // value selected in the dropdown field
    setSearchValue(searchValue);
    setFilterText(columnName);
    setFormTypeValue(dropdownValue);

    if (columnName === "updated_at") {
      setDateValue(value);
    }
  };

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const response = await get(
          `docgen/generate-forms`
      );
      setData(response?.data);
      setSelectedRows([]);
      setRowsSelection([]);
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //#endregion

  return (
    <div className="page-content-wrapper">
      <NotificationContainer notification={notification} />
      <Box className="w-100">
        <header className="section-heading">
          <div className="left-area">
          <FormSearchFilter
              options={[
                { value: "all", label: "All" },
                { value: "host_file_number", label: "Docket No." },
                { value: "form_code", label: "Form Code" },
                { value: "application_number", label: "Application No." },
                { value: "status", label: "Status" },
                { value: "updated_at", label: "Updated On" },
              ]}
              dateFiltersOptionsValueArray={["updated_at"]}
              onSearch={(values) => handleSearch(values)}
              dropdownArray={["status"]}
              defaultOption = { {value: "", label: "Select an option"} }
              dropdownOptions={{
                status: [
                  {
                    value: "Draft",
                    label: "Draft",
                  }/*,
                  {
                    value: "Completed",
                    label: "Completed",
                  },
                  {
                    value: "Pending for sign",
                    label: "Pending for Sign",
                  },
                  {
                    value: "Sent to sign",
                    label: "Sent for Sign",
                  },
                  {
                    value: "Ack. Awaited",
                    label: "Ack. Awaited",
                  },
                  {
                    value: "Filed",
                    label: "Filed",
                  },
                  {
                    value: "Signed",
                    label: "Signed",
                  },
                  {
                    value: "Saved in Workbench",
                    label: "Saved in Workbench",
                  },*/
                ],
              }}
            />
          </div>
          <div className="right-area">
            <section className="top-actions-section">
              <div className="buttons-group">
                {selectedRows.length > 0 && (
                  <ul>
                    {selectedRows.length == 1 &&
                        (allItemsHaveDesiredStatusForUpdateStatus) && (
                        <li>
                          <Button
                            type="button"
                            onClick={() => setUpdateStatusModalOpen(true)}
                          >
                            <div className="icon-area">
                              <AutorenewOutlinedIcon />
                            </div>
                            <p className="text-area">Update Status</p>
                          </Button>
                        </li>
                      )}
                    <li>
                      {allItemsHaveDesiredStatus && (
                        <Button type="button" onClick={handleDelete}>
                          <div className="icon-area">
                            <DeleteOutlineOutlinedIcon />
                          </div>
                          <p className="text-area">Delete</p>
                        </Button>
                      )}
                    </li>
                    {/*{readyToFile && (
                        <li>
                          <FileButton docketId={selectedRows[0]?.matter_id} forms={generatedFormData} onComplete={fetchData} notification={notification} setNotification={setNotification}/>
                        </li>
                      )}*/}
                    {allItemsHaveDesiredStatus && (
                      <li>
                        <Button type="button" onClick={() => handleRedirect()}>
                          <div className="icon-area">
                            <EditNoteOutlinedIcon />
                          </div>
                          <p className="text-area">Modify</p>
                        </Button>
                      </li>
                    )}
                    <li>
                      <Button
                        type="button"
                        onClick={() => handlePreviewRedirect()}
                      >
                        <div className="icon-area">
                          <VisibilityOutlinedIcon />
                        </div>
                        <p className="text-area">Preview</p>
                      </Button>
                    </li>
                    <li>

                    <Button type="button" onClick={() => handleDownload()}>
                        {isLoading ?  <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} />:
                        <>
                        <div className="icon-area">
                          <FileDownloadOutlinedIcon />
                        </div>
                        <p className="text-area">Download</p>
                        </>}
                      </Button>
                    </li>
                  </ul>
                )}
              </div>
            </section>
          </div>
        </header>
        <div>
          <MuiTableWrapper
            columns={columns}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}

            searchValue={searchValue}
            filterColumn={filterText}
            formTypeValue={formTypeValue}
            data={data}
            isFetching={isFetching}
            dateValue={dateValue}
            pageSize={50}

            emptyBody={
              <FallbackGeneratedFormMessage searchedKeyword={searchValue}/>
            }
            setItems={setItems}
            setForm={setForm}
            rowsSelection={rowsSelection}
            setRowsSelection={setRowsSelection}
          />
        </div>
      </Box>

      {
        // UPDATE STATUS MODAL POPUP
        updateStatusModalOpen && (
          <UpdateStatus
            isModalOpen={updateStatusModalOpen}
            handleModalClose={handleUpdateStatusModalClose}
            handleSubmit={handleUpdateStatusModalSubmit}
            form={form}
            setForm={setForm}
            isRowId={isRowId}
          />
        )
      }

      {
        // UPDATE FILE STATUS POPUP
        fileModalOpen &&  (
          <UpdateFileStatus
            isModalOpen={fileModalOpen}
            handleModalClose={handleFileModalClose}
            handleSubmit={handleFileModalSubmit}
            form={form}
            setForm={setForm}
            isRowId={isRowId}
          />
        )
      }

      {
        // SEND FOR SIGNATURE MODAL POPUP
        isSignModalOpen && selectedRows.length === 1 && (
          <SendForSignature
            isModalOpen={isSignModalOpen}
            handleModalClose={handleSignModalClose}
            items={items}
            onSubmit={handleSendForSign}
          />
        )
      }

      {
        <MatterDetailsModal
          open={isMatterDetailsOpen}
          handleClose={() => setIsMatterDetailsOpen(false)}
          id={isRowId}
          isXfa={isXfa}
        />
      }

      {
        <DownloadTypeModal
            downloadTypeModal={downloadTypeModal}
            setDownloadTypeModal={setDownloadTypeModal}
         selectType={selectType}
         setSelectType={setSelectType}
         downloadForms={downloadForms}
         selectedRows={selectedRows}
         />
      }
    </div>
  );
};

export default AllFormsListing;